import { Grid, Typography } from "@mui/material";

const PathIconDetails = ({ icon, title, description }) => {
    const styles = {
        dataContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        icon: {
            width: '18px',
            height: '18px',
            backgroundColor: '#EDEDED',
            padding: '15px',
            borderRadius: '50%',
            overflow: 'visible'
        },
        title: {
            fontSize: '12px',
            fontWeight: 'bold',
            textAlign: 'center',
            marginTop: '20px'
        },
        description: {
            fontSize: '10px',
            textAlign: 'center',
            marginTop: '5px',
            paddingLeft: '10px',
            paddingRight: '10px'
        }
    }
    
    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={styles.dataContainer}>
                <img src={icon} style={styles.icon}/>
            </Grid>
            <Grid xs={12} item sm={12} md={12} lg={12} xl={12}>
                <Typography sx={styles.title}>{title}</Typography>
            </Grid>
            <Grid xs={12} item sm={12} md={12} lg={12} xl={12}>
                <Typography sx={styles.description}>{description}</Typography>
            </Grid>
        </Grid>
    )
};

export default PathIconDetails;